module.exports = __webpack_public_path__ + "static/img/division_8.566d5f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_8.svg
// module id = APl7
// module chunks = 35